import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const Laroute = require('../../laroute');

const actions = {
    async storeCard({ commit, dispatch }, cardData) {
        let route = Laroute.route('franchise.setting.card.store');

        startLoading(dispatch, 'save-card');

        return await axios
            .post(route, cardData)
            .then(res => {
                endLoading(dispatch, 'save-card');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-card');
                throw err;
            });
    },

    async updateCard({ commit, dispatch }, cardData) {
        startLoading(dispatch, 'save-card');

        return await axios
            .patch(
                Laroute.route('franchise.setting.card.update', {
                    id: cardData.id,
                }),
                cardData,
            )
            .then(res => {
                endLoading(dispatch, 'save-card');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-card');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    actions,
};
